export const UPLOAD_DESIGN = "UPLOAD_DESIGN"
export const UPLOAD_DESIGN_SUCCESS = "UPLOAD_DESIGN_SUCCESS"
export const UPLOAD_DESIGN_FAIL = "UPLOAD_DESIGN_FAIL"


export const GET_DESIGN = "GET_DESIGN"
export const GET_DESIGN_SUCCESS = "GET_DESIGN_SUCCESS"
export const GET_DESIGN_FAIL = "GET_DESIGN_FAIL"


export const DELETE_DESIGN ="DELETE_DESIGN"
export const DELETE_DESIGN_SUCCESS="DELETE_DESIGN_SUCCESS"
export const DELETE_DESIGN_FAIL="DELETE_DESIGN_FAIL"